import { html } from 'lit';
// prettier-ignore
export const DeleteTooltip = html`<svg width="170" height="68" viewBox="0 0 170 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="170" height="68" rx="2" fill="white"/>
<mask id="mask0_16460_1246" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="68">
<rect width="170" height="68" rx="2" fill="white"/>
</mask>
<g mask="url(#mask0_16460_1246)">
<path d="M4 7C4 5.89543 4.89543 5 6 5H172V32H6C4.89543 32 4 31.1046 4 30V7Z" fill="#FDECEB"/>
<text fill="#121212" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="43.6364">不同用户可以决定自己保存、</tspan><tspan x="8" y="55.6364">分享和接受哪些数据。&#10;</tspan><tspan x="8" y="71.6364">例如，用户在飞机上编辑文档，</tspan><tspan x="8" y="83.6364">这些修改保存在自己的电脑中。</tspan><tspan x="8" y="95.6364">电脑重新连接网络后，修改会</tspan><tspan x="8" y="107.636">同步给其他用户。&#10;</tspan><tspan x="8" y="123.636">其他用户可以选择接受全部、</tspan><tspan x="8" y="135.636">部分修改，或者保留现有文档。</tspan></text>
<text fill="#EB4335" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="10" letter-spacing="0px"><tspan x="8" y="15.6364">在分布式系统中，数据可以具有</tspan><tspan x="8" y="27.6364">丰富而复杂的结构。&#10;</tspan></text>
</g>
</svg>
`;
